import { render, staticRenderFns } from "./groupEditor.vue?vue&type=template&id=7c2aaf3a&"
import script from "./groupEditor.vue?vue&type=script&lang=js&"
export * from "./groupEditor.vue?vue&type=script&lang=js&"
import style0 from "./groupEditor.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports